<template id="temp">
    <!-- vue实例外创建 -->
    <div class="basic">
        <div class="nav">
            <b>{{ navtext }}</b>
        </div>
        <div class="basicCon">
            <el-form
                :model="ruleForm"
                status-icon
                ref="ruleForm"
                label-width="130px"
                label-position="left"
                class="demo-ruleForm"
                @submit.native.prevent
            >
                <el-form-item label="照片" v-show="routeType == 'info'">
                    <div class="demo-image__preview avatorSpan" v-for="(item, index) in ruleForm.avator" :key="index" v-show="type=='Edit'">
                        <i class="el-icon-close" @click="delavator(item.id)"></i>
                        <el-image :src="'https://www.xsdjp.com' + item.url" :preview-src-list="['https://www.xsdjp.com' + item.url]"></el-image>
                    </div>
                    <div class="demo-image__preview avatorSpan" v-for="(item, index) in ruleForm.avatorinfo" :key="index"  v-show="type=='Add'">
                        <i class="el-icon-close" @click="delavatorAdd(item.id)"></i>
                        <el-image :src="'https://www.xsdjp.com' + item.url" :preview-src-list="['https://www.xsdjp.com' + item.url]"></el-image>
                    </div>
                    <div class="avator" @click="clickfile">
                        <i class="el-icon-plus avatar-uploader-icon"></i>
                    </div>
                    <input type="file" name="" ref="file" accept="image/jpeg,image/jpg,image/png" @change="changeImage" style="display: none" />
                </el-form-item>
                <el-form-item label="世序" v-show="routeType == 'info'">
                    第&nbsp;
                    <!-- <el-select v-model="ruleForm.shixu" placeholder="请选择世序" style="width:100px">
              <el-option value="">请选择</el-option>
              <el-option :value="item" v-for="item in 99" :label="toChies(item)" :key="item.index"></el-option>
          </el-select> -->
                    <span>{{ ruleForm.shixu }}</span>
                    &nbsp;世
                </el-form-item>
                <el-form-item label="是否改姓" v-show="routeType == 'info'">
                    <el-radio-group v-model="ruleForm.ischange" @input="inputIschange">
                        <el-radio :label="0">否</el-radio>
                        <el-radio :label="1">改姓</el-radio>
                    </el-radio-group>
                    &nbsp;&nbsp;&nbsp;
                    <p style="display: inline" v-if="ruleForm.ischange == 1">
                        改姓原因
                        <el-input v-model="ruleForm.gmyy" style="width: 300px"></el-input>
                    </p>
                </el-form-item>
                <el-form-item label="姓名*" v-show="routeType == 'info'">
                    <el-input v-model="ruleForm.xm" placeholder="姓名" style="width: 100px"></el-input>
                    谱名
                    <el-input v-model="ruleForm.pm" placeholder="未按辈分起名及改姓者" style="width: 100px"></el-input>
                    曾用名
                    <el-input v-model="ruleForm.cym" placeholder="曾用名" style="width: 100px"></el-input>
                    字
                    <el-input v-model="ruleForm.zi" placeholder="字" style="width: 100px"></el-input>
                    号
                    <el-input v-model="ruleForm.hao" placeholder="号" style="width: 100px"></el-input>
                </el-form-item>

                <el-form-item label="性别*" v-show="routeType == 'info'">
                    <el-radio-group v-model="ruleForm.sex" @change="sexFun">
                        <el-radio :label="0">男</el-radio>
                        <el-radio :label="1">女</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="民族*" v-show="routeType == 'info'">
                    <el-select
                        v-model="ruleForm.mz"
                        placeholder="请选择民族"
                        popper-class="lioverhide"
                        style="width: 120px"
                        :popper-append-to-body="false"
                    >
                        <el-option value="">请选择</el-option>
                        <el-option :value="item" v-for="item in $store.state.mzData" :key="item.index"></el-option>
                    </el-select>
                    &nbsp;
                    <el-checkbox v-model="ruleForm.gmzr">改民族为</el-checkbox>
                    &nbsp;&nbsp;
                    <el-select v-model="ruleForm.gmz" v-if="ruleForm.gmzr == 1" placeholder="请选择民族" style="width: 120px">
                        <el-option value="">请选择</el-option>
                        <el-option :value="item" v-for="item in $store.state.mzData" :key="item.index"></el-option>
                    </el-select>
                    &nbsp;&nbsp;
                    <p style="display: inline" v-if="ruleForm.gmzr == 1">
                        改民族原因
                        <el-input v-model="ruleForm.gmyy" style="width: 300px"></el-input>
                    </p>
                </el-form-item>
                <el-form-item label="分类" v-show="routeType == 'info'">
                    <el-radio-group v-model="ruleForm.type">
                        <el-radio :label="0">自然血亲</el-radio>
                        <el-radio :label="1">拟制血亲</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="生故状态" v-show="routeType == 'info'">
                    <el-radio-group v-model="ruleForm.sgzt" @change="sgztFun">
                        <el-radio :label="0">在世</el-radio>
                        <el-radio :label="1">已故</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="婚姻状态" v-show="routeType == 'info'">
                    <el-radio-group v-model="ruleForm.hyzt" @change="hyztFun">
                        <el-radio :label="0">未婚</el-radio>
                        <el-radio :label="1">已婚</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="排行" v-show="routeType == 'info'">
                    <!-- <el-input v-model="ruleForm.fqxm" placeholder="父亲姓名" style="width:120px"></el-input> -->
                    <span>{{ ruleForm.fqxm }}</span>
                    之&nbsp;
                    <el-select v-model="ruleForm.ph" placeholder="请选择排行" style="width: 90px">
                        <el-option value="">请选择</el-option>
                        <el-option :value="item.val" :label="item.key" v-for="(item, index) in $store.state.phData" :key="index"></el-option>
                    </el-select>
                    &nbsp;{{ ruleForm.sex == 0 ? "子" : "女" }}
                    &nbsp;
                    <!-- <p style="display: inline-block;"><i class="el-icon-info"></i>长≧次≧三≧四≧五≧六≧七....</p> -->
                </el-form-item>
                <el-form-item label="生日" v-show="routeType == 'info'">
                    <date
                        :propssr="ruleForm.sr"
                        :propsnlsr="ruleForm.nlsr"
                        :propscd="ruleForm.cd"
                        :propsnh="ruleForm.nh"
                        :propssdlr="ruleForm.sdlr"
                        :propsgynf="ruleForm.gynf"
                        :propscdday="ruleForm.cdday"
                        :propscdmonth="ruleForm.cdmonth"
                        :propssrlx="ruleForm.srlx"
                        propskey=""
                        @dateFun="dateFun"
                    ></date>
                    <div style="position: absolute; top: -5px; left: 266px">
                        <span v-if="ruleForm.sgzt == 0"> 现年 </span>
                        <!-- <span v-else-if="ruleForm.sgzt == 1"> 享年 </span> -->
                        <el-input v-model="ruleForm.age" v-if="ruleForm.sgzt == 0" style="width: 120px"></el-input>
                        <!-- <el-input v-model="ruleForm.xn" v-if="ruleForm.sgzt == 1" style="width:120px"></el-input> -->
                        <span v-if="ruleForm.sgzt == 0"> 岁 </span>
                    </div>
                </el-form-item>
                <el-form-item label="生肖" v-show="routeType == 'info'">
                    <el-select v-model="ruleForm.sx" placeholder="请选择属相" style="width: 200px">
                        <el-option value="">请选择</el-option>
                        <el-option :value="item" v-for="item in $store.state.sxData" :key="item.index"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="出生地" v-show="routeType == 'info'">
                    <Area
                        :propsinorout="ruleForm.inorout"
                        :propssheng="ruleForm.sheng"
                        :propsshi="ruleForm.shi"
                        :propsxian="ruleForm.xian"
                        :propszhen="ruleForm.zhen"
                        :propsdizhi="ruleForm.zdydz"
                        propskey=""
                        @area="areaFun"
                    ></Area>
                </el-form-item>

                <el-form-item label="是否迁徒" v-show="routeType == 'info'">
                    <el-radio-group v-model="ruleForm.sfqx">
                        <el-radio :label="0">无迁徒</el-radio>
                        <el-radio :label="1">有迁徒</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="迁徙情况" v-show="routeType == 'info' && ruleForm.sfqx == 1">
                    <migration :data="ruleForm.migrationList" ref="migrationRef"></migration>
                </el-form-item>
                <el-form-item :label="ruleForm.sgzt == 0 ? '常住地' : '生前常住地'" v-show="routeType == 'info'">
                    <Area
                        :propsinorout="ruleForm.czinorout"
                        :propssheng="ruleForm.czsheng"
                        :propsshi="ruleForm.czshi"
                        :propsxian="ruleForm.czxian"
                        :propszhen="ruleForm.czzhen"
                        :propsdizhi="ruleForm.czzdydz"
                        :propsdtdz="ruleForm.czdtdz"
                        :propsdwShow="ruleForm.sgzt == 0"
                        propskey="cz"
                        @area="areaFun"
                    ></Area>
                    <a
                        href="javascript:;"
                        @click="sameQrd()"
                        style="position: absolute; left: 660px; top: -5px; line-height: 20px; color: #409eff"
                        v-if="ruleForm.sfqx == 1"
                        >同迁入地</a
                    >
                    <a href="javascript:;" @click="sameCsd()" style="position: absolute; left: 660px;;top: 20px; line-height: 20px; color: #409eff"
                        >同出生地</a
                    >
                </el-form-item>
                <el-form-item label="成年身高" v-show="routeType == 'info'">
                    <el-select v-model="ruleForm.sg" placeholder="成年身高" style="width: 100px">
                        <el-option value="">请选择</el-option>
                        <el-option v-for="(item, index) in $utils.adultHeight()" :value="item" :key="index"></el-option>
                    </el-select>
                    &nbsp; cm &nbsp;&nbsp;&nbsp; 血型
                    <!-- <el-input v-model="ruleForm.xx" placeholder="血型" style="width:100px"></el-input> -->
                    <el-select v-model="ruleForm.xx" placeholder="血型" style="width: 100px">
                        <el-option value="">请选择</el-option>
                        <el-option value="A"></el-option>
                        <el-option value="B"></el-option>
                        <el-option value="AB"></el-option>
                        <el-option value="O"></el-option>
                        <el-option value="RH阳性"></el-option>
                        <el-option value="RH阴性"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="受教育程度" v-show="routeType == 'info'">
                    <el-select v-model="ruleForm.xueli" placeholder="受教育程度" style="width: 180px">
                        <el-option value="">请选择</el-option>
                        <el-option :value="item" v-for="item in $utils.xueliData()" :key="item.index"></el-option>
                    </el-select>
                    &nbsp; &nbsp; &nbsp;学位
                    <el-select v-model="ruleForm.xw" placeholder="学位" style="width: 100px">
                        <el-option value="">请选择</el-option>
                        <el-option value="无"></el-option>
                        <el-option value="博士"></el-option>
                        <el-option value="硕士"></el-option>
                        <el-option value="学士"></el-option>
                        <el-option value="副学士"></el-option>
                    </el-select>
                    &nbsp; &nbsp; &nbsp;毕业院校
                    <el-input v-model="ruleForm.byxx" placeholder="毕业院校" style="width: 120px"></el-input>
                </el-form-item>
                <el-form-item label="党派" v-show="routeType == 'info'">
                    <el-select v-model="ruleForm.dp" placeholder="党派" style="width: 100px">
                        <el-option value="">请选择</el-option>
                        <el-option value="无"></el-option>
                        <el-option value="中国共产党党员"></el-option>
                        <el-option value="中国国民党革命委员会党员"></el-option>
                        <el-option value="中国民主同盟会"></el-option>
                        <el-option value="中国民主建国会会员"></el-option>
                        <el-option value="中国民主促进会会员"></el-option>
                        <el-option value="中国农工民主党党员"></el-option>
                        <el-option value="中国致公党党员"></el-option>
                        <el-option value="九三学社会员"></el-option>
                        <el-option value="台湾民主自治同盟"></el-option>
                        <el-option value="中国国民党党员"></el-option>
                        <el-option value="中国民主进步党党员"></el-option>
                        <el-option value="中国前亲民党党员"></el-option>
                        <el-option value="中国新党党员"></el-option>
                        <el-option value="其他"></el-option>
                    </el-select>
                    &nbsp; &nbsp; &nbsp; 宗教信仰
                    <el-select v-model="ruleForm.zj" placeholder="宗教信仰" style="width: 100px">
                        <el-option value="">请选择</el-option>
                        <el-option value="无"></el-option>
                        <el-option value="佛教"></el-option>
                        <el-option value="道教"></el-option>
                        <el-option value="伊斯兰教"></el-option>
                        <el-option value="基督教"></el-option>
                        <el-option value="天主教"></el-option>
                        <el-option value="东正教"></el-option>
                        <el-option value="其他"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="职业或身份" v-show="routeType == 'info'" style="width: 90%">
                    <span v-for="(item, oIndex) in ruleForm.previous" :key="oIndex">
                        <treeSelect
                            :props="props"
                            :options="$utils.zyData()"
                            :value="item.zy"
                            :clearable="isClearable"
                            :accordion="isAccordion"
                            @getValue="getZyValue($event, oIndex, 'zy')"
                            v-if="oIndex == 0"
                        />
                        <el-input v-model="item.zy" placeholder="请输入" style="width: 100px; margin: 5px 10px 0 0" v-else></el-input>
                    </span>
                    <i class="el-icon-plus" @click="addprevious()" style="cursor: pointer"> 添加新职业或身份</i>
                </el-form-item>
                <el-form-item label="工作经历及 职务、职称、 所授衔级" v-show="routeType == 'info'" style="width: 90%">
                    <table border="1" cellspacing="0" cellpadding="10" width="100%" align="center">
                        <thead>
                            <tr class="firstHead">
                                <th rowspan="2">工作单位</th>
                                <th colspan="2">职务级别</th>
                                <th colspan="2">专业技术职称与级别</th>
                                <th rowspan="2">所授衔级</th>
                            </tr>
                            <tr class="twoHead">
                                <th>职务</th>
                                <th>级别</th>
                                <th>职称</th>
                                <th>级别</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in ruleForm.occupation" :key="index">
                                <td style="width: 200px">
                                    <el-input v-model="item.gzdw" style="width: 100%; margin: 5px 10px 0 0"></el-input>
                                </td>
                                <td>
                                    <el-input v-model="item.zw" style="width: 100%; margin: 5px 10px 0 0"></el-input>
                                </td>
                                <td>
                                    <treeSelect
                                        :props="props"
                                        :options="$utils.zwjbData()"
                                        :value="item.zwjb"
                                        :clearable="isClearable"
                                        :accordion="isAccordion"
                                        @getValue="getValue($event, index, 'zwjb')"
                                    />
                                </td>
                                <td>
                                    <el-input v-model="item.zc" style="width: 100%; margin: 5px 10px 0 0"></el-input>
                                </td>
                                <td>
                                    <el-select v-model="item.zcjb">
                                        <el-option value="">请选择</el-option>
                                        <el-option v-for="(zcjbItem, zcjbIndex) in $utils.zcjbData()" :key="zcjbIndex" :value="zcjbItem"></el-option>
                                    </el-select>
                                </td>
                                <td>
                                    <treeSelect
                                        :props="props"
                                        :options="$utils.jjzcjbData()"
                                        :value="item.scxj"
                                        :clearable="isClearable"
                                        :accordion="isAccordion"
                                        @getValue="getValue($event, index, 'scxj')"
                                    />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <i class="el-icon-plus" @click="addZy()" style="cursor: pointer"> 添加新工作经历</i>
                </el-form-item>
                <el-form-item label="生平简介" v-show="routeType == 'info'" style="width: 90%">
                    <el-input type="textarea" v-model="ruleForm.spjj" :autosize="{ minRows: 5, maxRows: 10 }"></el-input>
                </el-form-item>

                <!-- 联系信息 -->
                <el-form-item label="联系地址" v-show="routeType == 'personal'" style="width: 90%">
                    <el-input v-model="ruleForm.lxdz" placeholder="联系地址"></el-input>
                </el-form-item>
                <el-form-item label="联系电话" v-show="routeType == 'personal'" style="width: 90%">
                    <el-input v-model="ruleForm.lxdh" placeholder="联系电话"></el-input>
                </el-form-item>
                <el-form-item label="电子信箱" v-show="routeType == 'personal'" style="width: 90%">
                    <el-input v-model="ruleForm.dzyx" placeholder="电子信箱"></el-input>
                </el-form-item>
                <el-form-item label="个人微信" v-show="routeType == 'personal'" style="width: 90%">
                    <el-input v-model="ruleForm.grwx" placeholder="个人微信"></el-input>
                </el-form-item>
                <el-form-item label="说明" v-show="routeType == 'personal'" style="width: 90%">
                    <el-input
                        type="textarea"
                        placeholder="根据本人爱好公示联系信息，由此出现的法律问题由本人负责。"
                        v-model="ruleForm.grsm"
                        :autosize="{ minRows: 5, maxRows: 10 }"
                    ></el-input>
                </el-form-item>

                <!-- 去世安葬信息 -->
                <el-form-item label="去世时间" v-show="routeType == 'funeral'">
                    <date
                        :propssr="ruleForm.qssj"
                        :propsnlsr="ruleForm.qsnlsj"
                        :propscd="ruleForm.qscd"
                        :propsnh="ruleForm.qsnh"
                        :propssdlr="ruleForm.qssdlr"
                        :propsgynf="ruleForm.qsgynf"
                        :propscdday="ruleForm.qscdday"
                        :propscdmonth="ruleForm.qscdmonth"
                        :propssrlx="ruleForm.qssjlx"
                        propskey="qs"
                        @dateFun="dateFun"
                    ></date>
                </el-form-item>
                <el-form-item label="去世年龄" v-show="routeType == 'funeral'" style="width: 90%">
                    <el-select v-model="ruleForm.qsnian" placeholder="请选择">
                        <el-option value="">请选择</el-option>
                        <el-option value="夭亡"></el-option>
                        <el-option value="得年"></el-option>
                        <el-option value="享年"></el-option>
                    </el-select>
                    <el-input v-model="ruleForm.qszs" placeholder="周岁" style="width: 150px"></el-input>
                    周岁
                    <el-input v-model="ruleForm.qsxs" placeholder="虚岁" style="width: 90px"></el-input>
                    虚岁
                </el-form-item>
                <el-form-item label="遗传病史" v-show="routeType == 'funeral'" style="width: 90%">
                    <el-input v-model="ruleForm.ycbs" placeholder="遗传病史"></el-input>
                </el-form-item>
                <el-form-item label="安葬地点" v-show="routeType == 'funeral' && ruleForm.sgzt == 1" style="width: 90%">
                    <Area
                        :propsinorout="ruleForm.qsinorout"
                        :propssheng="ruleForm.qssheng"
                        :propsshi="ruleForm.qsshi"
                        :propsxian="ruleForm.qsxian"
                        :propszhen="ruleForm.qszhen"
                        :propsdizhi="ruleForm.qszdydz"
                        :propskey="'qs'"
                        @area="areaFun"
                    ></Area>
                    <a
                        href="javascript:;"
                        @click="qssameQrd()"
                        style="position: absolute; left: 560px; top: -5px; line-height: 20px; color: #409eff"
                        v-if="ruleForm.sfqx == 1"
                        >同迁入地</a
                    >
                    <a href="javascript:;" @click="qssameCsd()" style="position: absolute; left: 560px; top: 30px; line-height: 20px; color: #409eff"
                        >同出生地</a
                    >
                    <a href="javascript:;" @click="qssameCzd()" style="position: absolute; left: 560px; top: 65px; line-height: 20px; color: #409eff"
                        >同常住地</a
                    >
                    <div style="margin-top: 10px">
                        方位 &nbsp;&nbsp;&nbsp;
                        <el-input v-model="ruleForm.mzfw" placeholder="请输入方位" style="width: 200px"></el-input>
                    </div>
                </el-form-item>
                <el-form-item label="是否立碑" v-show="routeType == 'funeral'" style="width: 90%">
                    <el-radio-group v-model="ruleForm.sflb">
                        <el-radio :label="0">否</el-radio>
                        <el-radio :label="1">是</el-radio>
                    </el-radio-group>
                </el-form-item>

                <div v-for="(item, index) in ruleForm.spouseList" :key="index" v-if="routeType == 'spouse'">
                    <h1>配偶{{ index + 1 }}</h1>
                    <el-form-item label="配偶状态">
                        <el-radio-group v-model="item.pezt">
                            <el-radio :label="0">在世</el-radio>
                            <el-radio :label="1">已故</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="配偶性别">
                        <el-radio-group v-model="item.pexb">
                            <el-radio :label="0">男</el-radio>
                            <el-radio :label="1">女</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="婚姻状态">
                        <el-radio-group v-model="item.hyzt">
                            <el-radio :label="0">结婚</el-radio>
                            <el-radio :label="1">离异</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="婚姻方式">
                        <el-select v-model="item.hyfs">
                            <el-option value="">请选择</el-option>
                            <el-option value="配" v-if="item.pexb == 1"> 配<span style="color: #c2c2c2">(原配/大房)</span></el-option>
                            <el-option value="良配" v-if="item.pexb == 1"> 良配<span style="color: #c2c2c2">(二房)</span></el-option>
                            <el-option value="淑配" v-if="item.pexb == 1"> 淑配<span style="color: #c2c2c2">(三房)</span></el-option>
                            <el-option value="德配" v-if="item.pexb == 1"> 德配<span style="color: #c2c2c2">(四房)</span></el-option>
                            <el-option value="继配" v-if="item.pexb == 1"> 继配<span style="color: #c2c2c2">(原配亡，又配未婚女)</span> </el-option>
                            <el-option value="改配" v-if="item.pexb == 1"> 改配<span style="color: #c2c2c2">(原配离异，又配未婚女)</span></el-option>
                            <el-option value="续配" v-if="item.pexb == 1"> 续配<span style="color: #c2c2c2">(继配亡，三配未婚女)</span> </el-option>
                            <el-option value="再配" v-if="item.pexb == 1"> 再配<span style="color: #c2c2c2">(续配亡，四配未婚女)</span> </el-option>
                            <el-option value="又配" v-if="item.pexb == 1"> 又配<span style="color: #c2c2c2">(续配亡，五配未婚女)</span> </el-option>
                            <el-option value="娶" v-if="item.pexb == 1"> 娶<span style="color: #c2c2c2">(结婚对象为再婚女)</span> </el-option>
                            <el-option value="继娶" v-if="item.pexb == 1">
                                继娶<span style="color: #c2c2c2">(前妻亡或离，又娶再婚女)</span>
                            </el-option>
                            <el-option value="续娶" v-if="item.pexb == 1">
                                续娶<span style="color: #c2c2c2">(继娶亡或离，又娶再婚女)</span>
                            </el-option>
                            <el-option value="再娶" v-if="item.pexb == 1">
                                再娶<span style="color: #c2c2c2">(续娶亡或离，又娶再婚女)</span>
                            </el-option>
                            <el-option value="又娶" v-if="item.pexb == 1">
                                又娶<span style="color: #c2c2c2">(再娶亡或离，又娶再婚女)</span>
                            </el-option>
                            <el-option value="适" v-if="item.pexb == 0"> 适<span style="color: #c2c2c2">(初婚)</span></el-option>
                            <el-option value="再适" v-if="item.pexb == 0"> 再适<span style="color: #c2c2c2">(丧偶再嫁)</span> </el-option>
                            <el-option value="改适" v-if="item.pexb == 0"> 改适<span style="color: #c2c2c2">(离异再嫁)</span> </el-option>
                            <el-option value="又适" v-if="item.pexb == 0"> 又适<span style="color: #c2c2c2">(三婚)</span></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="配偶民族">
                        <el-select v-model="item.mz" placeholder="请选择配偶民族" style="width: 120px">
                            <el-option value="">请选择</el-option>
                            <el-option :value="item" v-for="item in $store.state.mzData" :key="item.index"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="配偶籍贯">
                        <Area
                            :propsinorout="item.jginorout || 1"
                            :propssheng="item.jgsheng"
                            :propsshi="item.jgshi"
                            :propsxian="item.jgxian"
                            :propszhen="item.jgzhen"
                            :propsdizhi="item.jgzdydz"
                            :propsdtdz="item.jgdtdz"
                            :propskey="'jg'"
                            :propskeyType="'spouseList'"
                            :propskeyInd="index"
                            @area="areaFun"
                        ></Area>
                    </el-form-item>
                    <el-form-item label="配偶父亲姓名">
                        <el-input v-model="item.fqxm" placeholder="父亲姓名" style="width: 120px"></el-input>
                        <!-- <span>{{ item.fqxm }}</span> -->
                        之&nbsp;
                        <el-select v-model="item.fqph" placeholder="请选择排行" style="width: 90px">
                            <el-option value="">请选择</el-option>
                            <el-option :value="item.val" :label="item.key" v-for="(item, index) in $store.state.phData" :key="index"></el-option>
                        </el-select>
                        &nbsp;{{ item.pexb == 0 ? "子" : "女" }}
                    </el-form-item>
                    <el-form-item label="配偶姓名">
                        <el-input v-model="item.pexm" placeholder="配偶姓名" style="width: 120px"></el-input>
                    </el-form-item>
                    <el-form-item label="配偶生日">
                        {{ item.nlsj }}
                        <date
                            :propssr="item.glsr"
                            :propsnlsr="item.nlsr"
                            :propscd="item.cd"
                            :propsnh="item.nh"
                            :propssdlr="item.sdlr"
                            :propsgynf="item.gynf"
                            :propscdday="item.cdday"
                            :propscdmonth="item.cdmonth"
                            :propssrlx="item.srlx"
                            propskey=""
                            propskeyType="spouseList"
                            :propskeyInd="index"
                            @dateFun="dateFun"
                        ></date>
                        <div style="position: absolute; top: -5px; left: 266px">
                            <span v-if="item.pezt == 0"> 现年 </span>
                            <!-- <span v-else-if="item.pezt == 1"> 享年 </span> -->
                            <el-input v-model="item.age" v-if="item.pezt == 0" style="width: 120px"></el-input>
                            <!-- <el-input v-model="item.xn" v-if="item.pezt == 1" style="width:120px"></el-input> -->
                            <span v-if="item.pezt == 0"> 岁 </span>
                        </div>
                    </el-form-item>
                    <el-form-item label="生肖">
                        <el-select v-model="item.shuxiang" placeholder="请选择属相" style="width: 200px">
                            <el-option value="">请选择</el-option>
                            <el-option :value="item" v-for="item in $store.state.sxData" :key="item.index"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="成年身高">
                        <el-select v-model="item.shengao" placeholder="成年身高" style="width: 100px">
                            <el-option value="">请选择</el-option>
                            <el-option v-for="(item, index) in $utils.adultHeight()" :value="item" :key="index"></el-option>
                        </el-select>
                        &nbsp; cm &nbsp;&nbsp;&nbsp; 血型
                        <el-select v-model="item.xuexing" placeholder="血型" style="width: 100px">
                            <el-option value="">请选择</el-option>
                            <el-option value="A"></el-option>
                            <el-option value="B"></el-option>
                            <el-option value="AB"></el-option>
                            <el-option value="O"></el-option>
                            <el-option value="RH阳性"></el-option>
                            <el-option value="RH阴性"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="受教育程度">
                        <el-select v-model="item.xueli" placeholder="受教育程度" style="width: 100px">
                            <el-option value="">请选择</el-option>
                            <el-option :value="item" v-for="item in $utils.xueliData()" :key="item.index"></el-option>
                        </el-select>
                        &nbsp; &nbsp; &nbsp;学位
                        <el-select v-model="item.xuewei" placeholder="学位" style="width: 100px">
                            <el-option value="">请选择</el-option>
                            <el-option value="无"></el-option>
                            <el-option value="博士"></el-option>
                            <el-option value="硕士"></el-option>
                            <el-option value="学士"></el-option>
                            <el-option value="副学士"></el-option>
                        </el-select>
                        &nbsp; &nbsp; &nbsp;毕业院校
                        <el-input v-model="item.byxx" placeholder="毕业院校" style="width: 120px"></el-input>
                    </el-form-item>
                    <el-form-item label="党派">
                        <el-select v-model="item.dangpai" placeholder="党派" style="width: 100px">
                            <el-option value="">请选择</el-option>
                            <el-option value="无"></el-option>
                            <el-option value="中国共产党党员"></el-option>
                            <el-option value="中国国民党革命委员会党员"></el-option>
                            <el-option value="中国民主同盟会"></el-option>
                            <el-option value="中国民主建国会会员"></el-option>
                            <el-option value="中国民主促进会会员"></el-option>
                            <el-option value="中国农工民主党党员"></el-option>
                            <el-option value="中国致公党党员"></el-option>
                            <el-option value="九三学社会员"></el-option>
                            <el-option value="台湾民主自治同盟"></el-option>
                            <el-option value="中国国民党党员"></el-option>
                            <el-option value="中国民主进步党党员"></el-option>
                            <el-option value="中国前亲民党党员"></el-option>
                            <el-option value="中国新党党员"></el-option>
                            <el-option value="其他"></el-option>
                        </el-select>
                        &nbsp; &nbsp; &nbsp; 宗教信仰
                        <el-select v-model="item.zongjiao" placeholder="宗教信仰" style="width: 100px">
                            <el-option value="">请选择</el-option>
                            <el-option value="无"></el-option>
                            <el-option value="佛教"></el-option>
                            <el-option value="道教"></el-option>
                            <el-option value="伊斯兰教"></el-option>
                            <el-option value="基督教"></el-option>
                            <el-option value="天主教"></el-option>
                            <el-option value="东正教"></el-option>
                            <el-option value="其他"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="职业或身份" style="width: 90%">
                        <span v-for="(item, oIndex) in item.previous" :key="oIndex">
                            <treeSelect
                                :props="props"
                                :options="$utils.zyData()"
                                :value="item.zy"
                                :clearable="isClearable"
                                :accordion="isAccordion"
                                @getValue="getZyValue($event, oIndex, 'zy', 'spouseList', index)"
                                v-if="oIndex == 0"
                            />
                            <el-input v-model="item.zy" placeholder="请输入" style="width: 100px; margin: 5px 10px 0 0" v-else></el-input>
                        </span>
                        <i class="el-icon-plus" @click="item.previous.push({})" style="cursor: pointer"> 添加新职业或身份</i>
                    </el-form-item>
                    <el-form-item label="工作经历及 职务、职称、 所授衔级" style="width: 90%">
                        <table border="1" cellspacing="0" cellpadding="10" width="100%" align="center">
                            <thead>
                                <tr class="firstHead">
                                    <th rowspan="2">工作单位</th>
                                    <th colspan="2">职务级别</th>
                                    <th colspan="2">专业技术职称与级别</th>
                                    <th rowspan="2">所授衔级</th>
                                </tr>
                                <tr class="twoHead">
                                    <th>职务</th>
                                    <th>级别</th>
                                    <th>职称</th>
                                    <th>级别</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(oItem, oIndex) in item.occupation" :key="oIndex">
                                    <td style="width: 200px">
                                        <el-input v-model="oItem.gzdw" style="width: 100%; margin: 5px 10px 0 0"></el-input>
                                    </td>
                                    <td>
                                        <el-input v-model="oItem.zw" style="width: 100%; margin: 5px 10px 0 0"></el-input>
                                    </td>
                                    <td>
                                        <treeSelect
                                            :props="props"
                                            :options="$utils.zwjbData()"
                                            :value="oItem.zwjb"
                                            :clearable="isClearable"
                                            :accordion="isAccordion"
                                            @getValue="getValue($event, oIndex, 'zwjb', 'spouseList', index)"
                                        />
                                    </td>
                                    <td>
                                        <el-input v-model="oItem.zc" style="width: 100%; margin: 5px 10px 0 0"></el-input>
                                    </td>
                                    <td>
                                        <!-- <treeSelect
                      :props="props"
                      :options="$utils.zwjbData()"
                      :value="oItem.zwjb"
                      :clearable="isClearable"
                      :accordion="isAccordion"
                      @getValue="getValue($event, oIndex, 'zwjb', 'spouseList', index)"
                  /> -->
                                        <el-select v-model="oItem.zcjb">
                                            <el-option value="">请选择</el-option>
                                            <el-option
                                                v-for="(zcjbItem, zcjbIndex) in $utils.zcjbData()"
                                                :key="zcjbIndex"
                                                :value="zcjbItem"
                                            ></el-option>
                                        </el-select>
                                        <!-- <el-select v-model="item.zwjb" >
                  <el-option value="">请选择</el-option>
                  <el-option v-for="(zwjbItem, zwjbIndex) in $utils.zcjbData()" :key="zwjbIndex" :value="zwjbItem"></el-option>
              </el-select> -->
                                    </td>
                                    <td>
                                        <treeSelect
                                            :props="props"
                                            :options="$utils.jjzcjbData()"
                                            :value="oItem.scxj"
                                            :clearable="isClearable"
                                            :accordion="isAccordion"
                                            @getValue="getValue($event, oIndex, 'scxj', 'spouseList', index)"
                                        />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <i class="el-icon-plus" @click="addZy(index)" style="cursor: pointer"> 添加新工作经历</i>
                    </el-form-item>
                    <el-form-item label="生平简介" style="width: 90%">
                        <el-input type="textarea" v-model="item.intro" :autosize="{ minRows: 5, maxRows: 10 }"></el-input>
                    </el-form-item>

                    <el-form-item label="是否生育" style="width: 90%">
                        <el-radio-group v-model="item.sfsy">
                            <el-radio :label="1">是</el-radio>
                            <el-radio :label="0">否</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="生育情况" style="width: 90%" v-if="item.sfsy == 1">
                        生
                        <el-select v-model="item.ezs" style="width: 100px"
                            >&nbsp;&nbsp;
                            <el-option value="0" label="请选择">请选择</el-option>
                            <el-option v-for="n in 10" :key="n" :value="n" :label="toChies(n)"></el-option> </el-select
                        >&nbsp;子&nbsp;&nbsp;
                        <el-select v-model="item.nes" style="width: 100px">
                            <el-option value="0" label="请选择">请选择</el-option>
                            <el-option v-for="n in 10" :key="n" :value="n" :label="toChies(n)"></el-option> </el-select
                        >&nbsp;女
                    </el-form-item>
                    <el-form-item label="儿子" style="width: 90%" v-if="item.ezs > 0 && item.sfsy == 1">
                        <el-input v-model="item.ezxm" placeholder="长子、次子、三子、四子、五子......"></el-input>
                    </el-form-item>
                    <el-form-item label="女儿" style="width: 90%" v-if="item.nes > 0 && item.sfsy == 1">
                        <el-input v-model="item.nexm" placeholder="长女、次女、三女、四女、五女......"></el-input>
                    </el-form-item>
                    <el-form-item label="去世时间" v-if="item.pezt == 1">
                        <date
                            :propssr="item.qssj"
                            :propsnlsr="item.qsnlsj"
                            :propscd="item.qscd"
                            :propsnh="item.qsnh"
                            :propssdlr="item.qssdlr"
                            :propsgynf="item.qsgynf"
                            :propscdday="item.qscdday"
                            :propscdmonth="item.qscdmonth"
                            :propssrlx="item.qssjlx"
                            propskey="qs"
                            propskeyType="spouseList"
                            :propskeyInd="index"
                            @dateFun="dateFun"
                        ></date>
                    </el-form-item>
                    <el-form-item label="去世年龄" style="width: 90%" v-if="item.pezt == 1">
                        <el-select v-model="item.qsnian">
                            <el-option value=""> 请选择</el-option>
                            <el-option value="夭亡"></el-option>
                            <el-option value="得年"></el-option>
                            <el-option value="享年"></el-option>
                        </el-select>
                        <el-input v-model="item.qszs" placeholder="周岁" style="width: 150px"></el-input>
                        周岁
                        <el-input v-model="item.qsxs" placeholder="虚岁" style="width: 90px"></el-input>
                        虚岁
                    </el-form-item>
                    <el-form-item label="遗传病史" style="width: 90%" v-if="item.pezt == 1">
                        <el-input v-model="item.ycbs"></el-input>
                    </el-form-item>
                    <el-form-item label="安葬方式" v-if="ruleForm.sgzt == 1 && item.pezt == 1">
                        <el-radio-group v-model="item.azfs" @onclick="printpezt(item)">
                            <el-radio :label="0">合葬</el-radio>
                            <el-radio :label="1">分葬</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="安葬地点" v-if="(item.pezt == 1 && item.azfs == 1) || (ruleForm.sgzt == 0 && item.pezt == 1)">
                        <Area
                            :propsinorout="item.mzinorout"
                            :propssheng="item.mzsheng"
                            :propsshi="item.mzshi"
                            :propsxian="item.mzxian"
                            :propszhen="item.mzzhen"
                            :propsdizhi="item.mzzdydz"
                            :propskey="'mz'"
                            :propskeyType="'spouseList'"
                            :propskeyInd="index"
                            @area="areaFun"
                        ></Area>
                        <a
                            href="javascript:;"
                            @click="peqssameQrd(item)"
                            style="position: absolute; left: 560px; top: -5px; line-height: 20px; color: #409eff"
                            v-if="ruleForm.sfqx == 1"
                            >同迁入地</a
                        >
                        <a
                            href="javascript:;"
                            @click="peqssameCsd(item)"
                            style="position: absolute; left: 560px; top: 30px; line-height: 20px; color: #409eff"
                            >同出生地</a
                        >
                        <a
                            href="javascript:;"
                            @click="peqssameCzd(item)"
                            style="position: absolute; left: 560px; top: 65px; line-height: 20px; color: #409eff"
                            >同常住地</a
                        >
                        <div style="margin-top: 10px">
                            方位 &nbsp;&nbsp;&nbsp;
                            <el-input v-model="item.mzdtdz" placeholder="请输入方位" style="width: 200px"></el-input>
                        </div>
                    </el-form-item>
                    <!-- <el-form-item label="埋葬地址" v-if="item.azfs == 1">
              <el-input v-model="item.mzdz" style="width:90%;margin:5px 10px 0 0"></el-input>
          </el-form-item>
          <el-form-item label="埋葬地图地址" v-if="item.azfs == 1">
              <el-input
                  v-model="item.mzdtdz"
                  @focus="mapOpen(index, item.mzdtdz, item.mzzdydz)"
                  style="width:90%;margin:5px 10px 0 0"
              ></el-input>
          </el-form-item>
          <el-form-item label="埋葬自定义地址" v-if="item.azfs == 1">
              <el-input v-model="item.mzzdydz" style="width:90%;margin:5px 10px 0 0"></el-input>
          </el-form-item>
          <el-form-item label="埋葬详细地址" v-if="item.azfs == 1">
              <el-input v-model="item.mzxxdz" style="width:90%;margin:5px 10px 0 0"></el-input>
          </el-form-item> -->

                    <el-form-item label="是否立碑" v-if="item.pezt == 1">
                        <el-radio-group v-model="item.sflb">
                            <el-radio :label="0">否</el-radio>
                            <el-radio :label="1">是</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </div>
                <div v-if="routeType == 'spouse'">
                    <!-- <i class="el-icon-plus" @click="addZy(index)" style="cursor: pointer;"></i> -->

                    <el-button type="text" @click="allspouseList()">添加配偶</el-button>
                    <!-- <i class="el-icon-plus" @click="addZy(index)" style="cursor: pointer;"></i> -->
                    <el-button type="text" @click="delspouseList()">删除配偶</el-button>
                </div>
                <el-form-item label="汇总信息" v-if="routeType == 'zlhz'">
                    <div style="font-size: 18px;">{{ ruleForm.xm + (ruleForm.shixu != null ? "&nbsp;（第" + ruleForm.shixu + "世）" : "") }}</div>
                    <el-input
                        type="textarea"
                        v-model="ruleForm.zlhz"
                        :rows="10"
                        placeholder="请输入内容"
                        style="width:80%"
                        @input="$forceUpdate()"
                    ></el-input>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" @click="submitForm()">{{ submitText }}</el-button>
                    <el-button type="primary" @click="cancelsubmit()">取消</el-button>
                    <el-button type="warning" v-if="routeType == 'zlhz'" @click="getzlhz()">重新获取汇总信息</el-button>
                </el-form-item>
            </el-form>
        </div>
        <!-- <el-dialog :visible.sync="dialogMap" width="500" class="map">
        <vmap @getLnglat="getPosi" :data="podtdz" :dzData="podizhi"></vmap>
    </el-dialog> -->
   

        <el-dialog :visible.sync="verifyMemberInfoDialog" width="500">
            <ul style="margin-bottom: 50px">
                <li v-for="(item, index) in verifyMemberInfoData" :key="index">{{ item }}</li>
            </ul>
            <!-- <table class="el-table" style="margin-bottom: 50px;">
          <thead>
              <tr>
                  <th width="100">检测项目</th>
                  <th width="100">逻辑关系</th>
                  <th width="100">值</th>
                  <th width="100">合理性提示</th>
                  <th width="100"></th>
              </tr>
          </thead>
          <tbody>
              <tr v-for="(item, index) in verifyMemberInfoData" :key="index">
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
              </tr>
          </tbody>
      </table> -->
            <div style="position: absolute; bottom: 10px; right: 10px">
                <el-button type="primary" @click="determine()">坚持提交</el-button>
                <el-button @click="cancellation()">返回修改</el-button>
            </div>
        </el-dialog>
        <el-dialog :visible.sync="uploadAvatorChild" width="60%" @close="closeFun">
            <div style="width:100%;height:400px">
                <vue-cropper autoCrop :img="imageUrl" ref="cropper" centerBox/>
            </div>
            <el-button type="primary" @click="getCropData()" block style="margin:10px 0">上传</el-button>
        </el-dialog>
    </div>
</template>
<script>
import api from "@/request/api";

import date from "@/components/date.vue";
import Area from "@/components/area.vue";
import migration from "./migrationForm.vue";
import vmap from "@/components/vmap.vue";
import treeSelect from "@/components/treeSelect.vue";

export default {
    props: ["pType"],
    data() {
        return {
            navtext: "基本信息",
            submitText: "保存并填写下一项",
            type: "Add",
            routeType: "info",
            ruleForm: {},
            poindex: "",
            podtdz: "",
            podizhi: "",
            isClearable: true, // 可清空（可选）
            isAccordion: true, // 可收起（可选）
            props: {
                // 配置项（必选）
                value: "val",
                label: "val",
                children: "children"
                // disabled:true
            },
            verifyMemberInfoData: [],
            verifyMemberInfoDialog: false,
            zlhzData: {},
            memberData: {},
            uploadAvator: false,
            uploadAvatorChild: false,
            avatorIm: "",
            imageUrl: "",
        };
    },
    created() {
        this.ruleForm = this.$utils.formData();
        this.ruleForm.onceid = sessionStorage.getItem("memberId");
        this.ruleForm.familyid = localStorage.getItem("fid");
     
        let data = this.$qs.parse(sessionStorage.getItem("form"));
        this.ruleForm.mz = data.mz;
        this.ruleForm.xm = data.xm;
        this.ruleForm.fqxm = data.pname;
        this.ruleForm.shixu = data.shixu;
        this.ruleForm.pname = data.pname;
        this.ruleForm.relation = data.relation;
        if (this.ruleForm.relation == 2) {
            this.ruleForm.shixu = Number(this.ruleForm.shixu) + 1;
        }
        this.ruleForm.sex = Number(data.sex);
        if (sessionStorage.getItem("memberType") == "Edit") {
            this.type = "Edit";
            this.edit();
        } else {
            this.type = "Add";
            this.ruleForm.isupdate = 0;
            this.ruleForm.spouseList.push(this.$utils.sData());
            this.ruleForm.migrationList.push(this.$utils.mData());
        }
        this.sgztFun(this.ruleForm.sgzt);
        this.hyztFun(this.ruleForm.hyzt);
        this.sexFun(this.ruleForm.sex);
        console.log(this.ruleForm,'-------this.roleForm')
        console.log(this.ruleForm.avatorinfo,'-------this.roleForm.avator')
    },
    methods: {
        edit() {
            api.memberGet(sessionStorage.getItem("memberId")).then((res) => {
                let data = res.data;
                
                data.isupdate = 1;
                data.familyid = localStorage.getItem("fid");
                // data.fqxm = this.$store.state.pxm;
                res.data.sex = res.data.sex ? res.data.sex : 0;
                res.data.sfqx = res.data.sfqx ? res.data.sfqx : 0;
                // if (res.data.nlsr) {
                //     let age = new Date().getFullYear() - data.nlsr.split("-")[0];
                //     this.$set(res.data, "age", age);
                // }
                if (!data.occupation) {
                    data.occupation = [{}];
                }
                if (!data.previous) {
                    data.previous = [{ zy: "" }];
                }
                for (let i = 0; i < data.spouseList.length; i++) {
                    data.spouseList[i].isupdate = 1;
                    if (res.data.spouseList[i].hyfs) {
                        if (res.data.spouseList[i].hyfs.indexOf("(") != -1) {
                            data.spouseList[i].hyfs = data.spouseList[i].hyfs.split("(")[0];
                        }
                    }
                    if (!res.data.spouseList[i].occupation) {
                        data.spouseList[i].occupation = [{}];
                    }
                    if (!res.data.spouseList[i].previous) {
                        data.spouseList[i].previous = [{ zy: "" }];
                    }
                    // if (res.data.spouseList[i].nlsr) {
                    //     let age = new Date().getFullYear() - data.nlsr.split("-")[0];
                    //     this.$set(res.data.spouseList[i], "age", age);
                    // }
                }
                for (let i = 0; i < data.migrationList.length; i++) {
                    data.migrationList[i].isupdate = 1;
                }
                this.$set(this, "ruleForm", data);
                this.$store.dispatch("getActionsData", { key: "sgztData", val: res.data.sgzt == 1 ? true : false });
                this.$store.dispatch("getActionsData", { key: "hyztData", val: res.data.hyzt == 1 ? true : false });
                this.$store.dispatch("getActionsData", { key: "infoMemberData", val: this.ruleForm });
                if ((res.data.migrationList.length == 0) == 1) {
                    let mData = this.$utils.mData();
                    mData.isadd = 1;
                    this.ruleForm.migrationList.push(mData);
                }
                if (res.data.spouseList.length == 0) {
                    let sData = this.$utils.sData();
                    sData.isadd = 1;
                    sData.pexb = data.sex == 1 ? 0 : 1;
                    sData.mid = data.id;
                    sData.hyfs = sData.hyfs == "0" ? "" : sData.hyfs;
                    this.ruleForm.spouseList.push(sData);
                }
            });
            this.$forceUpdate();
        },
        addzlhz() {
            if (typeof this.ruleForm.zlhz == "undefined" || this.ruleForm.zlhl == "") {
                api.getzlhzByMember(this.ruleForm).then((res) => {
                    this.zlhzData = res.data;
                    this.$set(this.ruleForm, "zlhz", res.data.info);
                });
            }
        },
        getzlhz() {
            this.$alert("确定要重新汇总资料？", {
                confirmButtonText: "确定",
                callback: (action) => {
                    if (action == "confirm") {
                        api.getzlhzByMember(this.ruleForm).then((res) => {
                            this.zlhzData = res.data;
                            this.$set(this.ruleForm, "zlhz", res.data.info);
                        });
                    }
                }
            });
        },
        // ruleForm.zlhz
        submitForm() {
            if (this.routeType == "zlhz") {
                this.apiVerifyMemberInfo();
            }

            if (this.routeType == "personal") {
                this.routeType = "zlhz";
                this.$emit("liType", "zlhz");
                this.addzlhz();
            }

            if (this.routeType == "spouse") {
                if (this.ruleForm.sgzt != 1) {
                    this.routeType = "personal";
                    this.$emit("liType", "personal");
                } else {
                    this.routeType = "zlhz";
                    this.$emit("liType", "zlhz");
                    this.addzlhz();
                }
            }

            if (this.routeType == "funeral") {
                // 逝葬
                if (this.ruleForm.hyzt == 1) {
                    // 婚姻状态
                    this.routeType = "spouse";
                    this.$emit("liType", "spouse");
                } else {
                    this.routeType = "zlhz";
                    this.$emit("liType", "zlhz");
                    this.addzlhz();
                }
            }

            if (this.routeType == "info") {
                if (this.ruleForm.sgzt == 1) {
                    this.routeType = "funeral";
                    this.$emit("liType", "funeral");
                } else {
                    if (this.ruleForm.hyzt == 1) {
                        // 婚姻状态
                        this.routeType = "spouse";
                        this.$emit("liType", "spouse");
                    } else {
                        this.routeType = "personal";
                        this.$emit("liType", "personal");
                    }
                }
            }
        },
        apiVerifyMemberInfo() {
            for (let i = 0; i < this.$refs.migrationRef.mdelData.length; i++) {
                this.$refs.migrationRef.migrationForm.migrationList.push(this.$refs.migrationRef.mdelData[i]);
            }
            this.ruleForm.migrationList = this.$refs.migrationRef.migrationForm.migrationList;
            api.verifyMemberInfo(this.ruleForm).then((res) => {
                this.verifyMemberInfoData = res.data;
                if (res.data.length == 0) {
                    this.apiMember();
                } else {
                    this.verifyMemberInfoDialog = true;
                }
            });
        },
        determine() {
            this.apiMember();
        },
        cancellation() {
            this.verifyMemberInfoDialog = false;
        },
        cancelsubmit() {
            this.$emit("showFun", true);
        },
        emitFun() {
            this.$emit("submitFun", this.memberData);
        },
        apiMember() {
            api["member" + this.type](this.ruleForm).then((res) => {
                if (res.code == 0) {
                    this.$message({
                        message: "操作成功"
                    });
                    this.memberData = res.data;
                    this.emitFun();
                    this.$store.dispatch("getActionsData", { key: "infoMemberData", val: {} });
                } else {
                    this.$message({
                        message: res.msg,
                        type: "warning"
                    });
                }
            });
        },
        dateFun(data) {
            console.log(data, "data");
            /*  配偶生日
      item.glsr item.nlsr" item.cd" item.nh" item.sdlr" item.gynf" item.srlx"
      item.qssj item.qsnlsj" item.qscd" item.qsnh" item.qssdlr" item.qsgynf" item.qssjlx"
      */
            if (data.keyType == "spouseList") {
                if (data.nlsr != undefined && data.nlsr != "" && data.nlsr != null) {
                    let age = new Date().getFullYear() - data.nlsr.split("-")[0];
                    this.$set(this.ruleForm.spouseList[data.keyInd], "age", age);
                }
                this.$set(this.ruleForm.spouseList[data.keyInd], data.key == "qs" ? "qssj" : "glsr", data.sr);
                this.$set(this.ruleForm.spouseList[data.keyInd], data.key == "qs" ? "qsnlsj" : "nlsr", data.nlsr);
                this.$set(this.ruleForm.spouseList[data.keyInd], data.key + "cd", data.cd);
                this.$set(this.ruleForm.spouseList[data.keyInd], data.key + "nh", data.nh);
                this.$set(this.ruleForm.spouseList[data.keyInd], data.key + "sdlr", data.sdlr);
                this.$set(this.ruleForm.spouseList[data.keyInd], data.key + "gynf", data.gynf);
                this.$set(this.ruleForm.spouseList[data.keyInd], data.key + "cdmonth", data.month);
                this.$set(this.ruleForm.spouseList[data.keyInd], data.key + "cdday", data.day);
                this.$set(this.ruleForm.spouseList[data.keyInd], data.key == "qs" ? "qssjlx" : "srlx", data.srlx);
                let sry = "";
                let qssry = "";
                if (this.ruleForm.spouseList[data.keyInd].srlx == 0 && typeof this.ruleForm.spouseList[data.keyInd].glsr != "undefined") {
                    if (this.ruleForm.spouseList[data.keyInd].glsr) {
                        if (
                            this.ruleForm.spouseList[data.keyInd].glsr != undefined &&
                            this.ruleForm.spouseList[data.keyInd].glsr != "" &&
                            this.ruleForm.spouseList[data.keyInd].glsr != null
                        ) {
                            sry = this.ruleForm.spouseList[data.keyInd].glsr.split("-")[0];
                        }
                    }
                } else if (this.ruleForm.spouseList[data.keyInd].srlx == 1 && typeof this.ruleForm.spouseList[data.keyInd].gynf != "undefined") {
                    sry = this.ruleForm.spouseList[data.keyInd].gynf;
                }

                if (this.ruleForm.spouseList[data.keyInd].qssjlx == 0 && this.ruleForm.spouseList[data.keyInd].qssj != "undefined") {
                    if (
                        this.ruleForm.spouseList[data.keyInd].qssj != undefined &&
                        this.ruleForm.spouseList[data.keyInd].qssj != "" &&
                        this.ruleForm.spouseList[data.keyInd].qssj != null
                    ) {
                        qssry = this.ruleForm.spouseList[data.keyInd].qssj.split("-")[0];
                    }
                } else if (
                    this.ruleForm.spouseList[data.keyInd].qssjlx == 1 &&
                    typeof this.ruleForm.spouseList[data.keyInd][data.key + "gynf"] != "undefined"
                ) {
                    qssry = this.ruleForm.spouseList[data.keyInd][data.key + "gynf"];
                }
                if (sry && qssry && qssry > sry) {
                    //this.$set(this.ruleForm.spouseList[data.keyInd], data.key == "qs" ? "qssjlx" : "srlx", 0);
                    this.ruleForm.spouseList[data.keyInd].qszs = qssry - sry;
                    this.ruleForm.spouseList[data.keyInd].qsxs = qssry - sry + 1;
                } else {
                    this.ruleForm.spouseList[data.keyInd].qszs = "";
                    this.ruleForm.spouseList[data.keyInd].qsxs = "";
                    this.ruleForm.spouseList[data.keyInd].qsnian = "";
                }
                if (data.key == "qs" && this.ruleForm.spouseList[data.keyInd].qszs != "") {
                    // 1--17周岁为【夭亡】，18--49周岁为【得年】，50周岁以上为【享年】。
                    if (this.ruleForm.spouseList[data.keyInd].qszs <= 17) {
                        this.$set(this.ruleForm.spouseList[data.keyInd], "qsnian", "夭亡");
                    } else if (this.ruleForm.spouseList[data.keyInd].qszs > 17 && this.ruleForm.spouseList[data.keyInd].qszs <= 49) {
                        this.$set(this.ruleForm.spouseList[data.keyInd], "qsnian", "得年");
                    } else if (this.ruleForm.spouseList[data.keyInd].qszs >= 50) {
                        this.$set(this.ruleForm.spouseList[data.keyInd], "qsnian", "享年");
                    }
                }
            } else {
                if (data.nlsr != undefined && data.nlsr != "" && data.nlsr != null) {
                    let age = new Date().getFullYear() - data.nlsr.split("-")[0];
                    this.$set(this.ruleForm, "age", age);
                }

                this.$set(this.ruleForm, data.key == "qs" ? "qssj" : "sr", data.sr);
                this.$set(this.ruleForm, data.key == "qs" ? "qsnlsj" : "nlsr", data.nlsr);
                this.$set(this.ruleForm, data.key + "cd", data.cd);
                this.$set(this.ruleForm, data.key + "cdmonth", data.month);
                this.$set(this.ruleForm, data.key + "cdday", data.day);
                this.$set(this.ruleForm, data.key + "nh", data.nh);
                this.$set(this.ruleForm, data.key + "sdlr", data.sdlr);
                this.$set(this.ruleForm, data.key + "gynf", data.gynf);
                this.$set(this.ruleForm, data.key == "qs" ? "qssjlx" : "srlx", data.srlx); //data.key + "srlx", data.srlx);
                // type 0 是阳历 type1 是阴历
                let sry = "";
                let qssry = "";
                if (this.ruleForm.srlx == 0 && typeof this.ruleForm.nlsr != "undefined") {
                    if (this.ruleForm.nlsr != undefined && this.ruleForm.nlsr != "" && this.ruleForm.nlsr != null) {
                        sry = this.ruleForm.nlsr.split("-")[0];
                    }
                } else if (this.ruleForm.srlx == 1 && typeof this.ruleForm.gynf != "undefined") {
                    sry = this.ruleForm.gynf;
                }
                if (this.ruleForm.qssjlx == 0 && typeof this.ruleForm.qsnlsj != "undefined") {
                    if (this.ruleForm.qsnlsj != undefined && this.ruleForm.qsnlsj != "" && this.ruleForm.qsnlsj != null) {
                        qssry = this.ruleForm.qsnlsj.split("-")[0];
                    }
                } else if (this.ruleForm.qssjlx == 1 && typeof this.ruleForm[data.key + "gynf"] != "undefined") {
                    qssry = this.ruleForm[data.key + "gynf"];
                }
                if (sry && qssry && qssry > sry) {
                    //this.$set(this.ruleForm, data.key == "qs" ? "qssjlx" : "srlx", 0);
                    this.ruleForm.qszs = qssry - sry;
                    this.ruleForm.qsxs = qssry - sry + 1;
                } else {
                    this.ruleForm.qszs = "";
                    this.ruleForm.qsxs = "";
                    this.ruleForm.qsnian = "";
                }
                if (data.key == "qs" && this.ruleForm.qszs != "") {
                    // 1--17周岁为【夭亡】，18--49周岁为【得年】，50周岁以上为【享年】。
                    if (this.ruleForm.qszs <= 17) {
                        this.$set(this.ruleForm, "qsnian", "夭亡");
                    } else if (this.ruleForm.qszs > 17 && this.ruleForm.qszs <= 49) {
                        this.$set(this.ruleForm, "qsnian", "得年");
                    } else if (this.ruleForm.qszs >= 50) {
                        this.$set(this.ruleForm, "qsnian", "享年");
                    }
                }
            }

            this.zodiacFun(1, data);
        },
        // 时间
        getTime(date, monthNum) {
            //      function GetNextMonthDay() {
            if (!date) {
                return;
            }
            var dateArr = date.split("-");
            var year = dateArr[0]; //获取当前日期的年份
            var month = dateArr[1]; //获取当前日期的月份
            var day = dateArr[2]; //获取当前日期的日
            var days = new Date(year, month, 0);
            days = days.getDate(); //获取当前日期中的月的天数
            var year2 = year;
            var month2 = parseInt(month) + parseInt(monthNum);
            if (month2 > 12) {
                year2 = parseInt(year2) + parseInt(parseInt(month2) / 12 == 0 ? 1 : parseInt(month2) / 12);
                month2 = parseInt(month2) % 12;
            }
            var day2 = day;
            var days2 = new Date(year2, month2, 0);
            days2 = days2.getDate();
            if (day2 > days2) {
                day2 = days2;
            }
            if (month2 < 10) {
                month2 = "0" + month2;
            }

            var t2 = year2 + "-" + month2 + "-" + day2;
            return t2;
        },
        zodiacFun(type, data) {
            if (data.nlsr.split("-")[0] || data.gynf) {
                api.zodiac(
                    this.$qs.stringify({
                        type: type,
                        year: data.nlsr.split("-")[0] || data.gynf
                    })
                ).then((res) => {
                    if (data.keyType == "spouseList") {
                        this.$set(this.ruleForm.spouseList[data.keyInd], "shuxiang", res.data);
                    } else {
                        this.$set(this.ruleForm, "sx", res.data);
                    }
                });
            }
        },
        // 地址
        areaFun(data) {
            if (data.keyType == "spouseList") {
                this.$set(this.ruleForm.spouseList[data.keyInd], data.key + "inorout", data.inorout);
                this.$set(this.ruleForm.spouseList[data.keyInd], data.key + "sheng", data.sheng);
                this.$set(this.ruleForm.spouseList[data.keyInd], data.key + "shi", data.shi);
                this.$set(this.ruleForm.spouseList[data.keyInd], data.key + "xian", data.xian);
                this.$set(this.ruleForm.spouseList[data.keyInd], data.key + "zhen", data.zhen);
                this.$set(this.ruleForm.spouseList[data.keyInd], data.key + "zdydz", data.dizhi);
            } else {
                this.$set(this.ruleForm, data.key + "inorout", data.inorout);
                this.$set(this.ruleForm, data.key + "sheng", data.sheng);
                this.$set(this.ruleForm, data.key + "shi", data.shi);
                this.$set(this.ruleForm, data.key + "xian", data.xian);
                this.$set(this.ruleForm, data.key + "zhen", data.zhen);
                this.$set(this.ruleForm, data.key + "zdydz", data.dizhi);
                if (data.key == "cz" && this.ruleForm.sgzt == 0) {
                    this.$set(this.ruleForm, data.key + "dtdz", data.dtdz);
                }
            }
        },

        // 上传图片
        clickfile() {
            this.$refs.file.click();
        },
        changeImage(e) {
            // console.log(e)
            var file = e.target.files[0];
            var reader = new FileReader();
            var that = this;
            reader.readAsDataURL(file);
            reader.onload = function(e) {
                console.log(this.result,'----this.result')
                that.imageUrl = this.result;
                that.avatorIm = this.result;
                that.uploadAvatorChild=true
            };
        },
        getCropData() {
            this.$refs.cropper.getCropData((data) => {
                api.uploadAvator(
                    this.$qs.stringify({
                            fid: localStorage.getItem("fid"),
                            mid: sessionStorage.getItem("memberId"),
                            img: data
                        })
                    ).then((res) => {
                        if (res.code == 0) {
                            this.$message({
                                message: "上传成功",
                                type: "success"
                            });
                            
                            if (this.type == "Edit") {
                                this.ruleForm.avator.push(res.data);
                            }else if(this.type == "Add") {
                                this.ruleForm.avatorinfo.push(res.data);
                            }
                            this.uploadAvatorChild = false;
                        } else {
                            this.$message({
                                essage: res.msg,
                                type: "warning"
                            });
                        }
                    });
                              
            })
        },
        closeFun() {
            this.$refs.file.value = "";
        },
        delavator(id) {
            if(id == 0){
                for (let i = 0; i < this.ruleForm.avator.length; i++) {
                    if (this.ruleForm.avator[i].id == id) {
                        this.ruleForm.avator.splice(i, 1);
                    }
                }
                return;
            }
            this.$alert("确定删除吗", {
                confirmButtonText: "确定",
                callback: (action) => {
                    if (action == "confirm") {
                        api.delAvator(this.$qs.stringify({ id: id })).then((res) => {
                            for (let i = 0; i < this.ruleForm.avator.length; i++) {
                                if (this.ruleForm.avator[i].id == id) {
                                    this.ruleForm.avator.splice(i, 1);
                                }
                            }
                        });
                    }
                }
            });
        },
        delavatorAdd(id) {
            if(id == 0){
                for (let i = 0; i < this.ruleForm.avatorinfo.length; i++) {
                    if (this.ruleForm.avatorinfo[i].id == id) {
                        this.ruleForm.avatorinfo.splice(i, 1);
                    }
                }
                return;
            }
            this.$alert("确定删除吗", {
                confirmButtonText: "确定",
                callback: (action) => {
                    if (action == "confirm") {
                        api.delAvator(this.$qs.stringify({ id: id })).then((res) => {
                            for (let i = 0; i < this.ruleForm.avatorinfo.length; i++) {
                                if (this.ruleForm.avatorinfo[i].id == id) {
                                    this.ruleForm.avatorinfo.splice(i, 1);
                                }
                            }
                        });
                    }
                }
            });
        },
        //生故状态
        sgztFun(e) {
            this.$store.dispatch("getActionsData", { key: "sgztData", val: e == 1 ? true : false });
        },
        // 婚姻状态
        hyztFun(e) {
            this.$store.dispatch("getActionsData", { key: "hyztData", val: e == 1 ? true : false });
            if (e == 1 && (this.ruleForm.spouseList == undefined || this.ruleForm.spouseList.length == 0)) {
                this.ruleForm.spouseList.push(this.spouseList);
                for (let i = 0; i < this.ruleForm.spouseList.length; i++) {
                    this.ruleForm.spouseList[i].pexb = this.ruleForm.sex == 1 ? 0 : 1;
                }
            } else {
                // this.spouseListSex();
                for (let i = 0; i < this.ruleForm.spouseList.length; i++) {
                    this.ruleForm.spouseList[i].pexb = this.ruleForm.sex == 1 ? 0 : 1;
                }
            }
        },
        sexFun() {
            for (let i = 0; i < this.ruleForm.spouseList.length; i++) {
                this.ruleForm.spouseList[i].pexb = this.ruleForm.sex == 1 ? 0 : 1;
            }
        },
        addZy(index) {
            if (index != undefined) {
                this.ruleForm.spouseList[index].occupation.push({});
            } else {
                this.ruleForm.occupation.push({});
            }
        },
        addprevious(index) {
            if (index != undefined) {
                this.ruleForm.spouseList[index].previous.push({});
            } else {
                this.ruleForm.previous.push({});
            }
        },
        sameCsd() {
            this.$set(this.ruleForm, "czinorout", this.ruleForm.inorout);
            this.$set(this.ruleForm, "czsheng", this.ruleForm.sheng);
            this.$set(this.ruleForm, "czshi", this.ruleForm.shi);
            this.$set(this.ruleForm, "czxian", this.ruleForm.xian);
            this.$set(this.ruleForm, "czzhen", this.ruleForm.zhen);
            this.$set(this.ruleForm, "czzdydz", this.ruleForm.zdydz);
        },
        sameQrd() {
            let ind = this.$refs.migrationRef.migrationForm.migrationList.length - 1;
            let data = this.$refs.migrationRef.migrationForm.migrationList;
            if (data[ind].qrsheng && this.ruleForm.sfqx == 1) {
                this.$set(this.ruleForm, "czinorout", data[ind].qrinorout);
                this.$set(this.ruleForm, "czsheng", data[ind].qrsheng);
                this.$set(this.ruleForm, "czshi", data[ind].qrshi);
                this.$set(this.ruleForm, "czxian", data[ind].qrxian);
                this.$set(this.ruleForm, "czzhen", data[ind].qrzhen);
                this.$set(this.ruleForm, "czzdydz", data[ind].qrdizhi);
            } else {
                this.$message({ message: "请先选择迁入地", type: "warning" });
            }
        },
        qssameCsd() {
            this.$set(this.ruleForm, "qsinorout", this.ruleForm.inorout);
            this.$set(this.ruleForm, "qssheng", this.ruleForm.sheng);
            this.$set(this.ruleForm, "qsshi", this.ruleForm.shi);
            this.$set(this.ruleForm, "qsxian", this.ruleForm.xian);
            this.$set(this.ruleForm, "qszhen", this.ruleForm.zhen);
            this.$set(this.ruleForm, "qszdydz", this.ruleForm.zdydz);
        },
        qssameCzd() {
            this.$set(this.ruleForm, "qsinorout", this.ruleForm.czinorout);
            this.$set(this.ruleForm, "qssheng", this.ruleForm.czsheng);
            this.$set(this.ruleForm, "qsshi", this.ruleForm.czshi);
            this.$set(this.ruleForm, "qsxian", this.ruleForm.czxian);
            this.$set(this.ruleForm, "qszhen", this.ruleForm.czzhen);
            this.$set(this.ruleForm, "qszdydz", this.ruleForm.czzdydz);
        },
        qssameQrd() {
            let ind = this.$refs.migrationRef.migrationForm.migrationList.length - 1;
            let data = this.$refs.migrationRef.migrationForm.migrationList;
            if (data[ind].qrsheng && this.ruleForm.sfqx == 1) {
                this.$set(this.ruleForm, "qsinorout", data[ind].qrinorout);
                this.$set(this.ruleForm, "qssheng", data[ind].qrsheng);
                this.$set(this.ruleForm, "qsshi", data[ind].qrshi);
                this.$set(this.ruleForm, "qsxian", data[ind].qrxian);
                this.$set(this.ruleForm, "qszhen", data[ind].qrzhen);
                this.$set(this.ruleForm, "qszdydz", data[ind].qrdizhi);
            } else {
                this.$message({ message: "请先选择迁入地", type: "warning" });
            }
        },
        peqssameCsd(item) {
            this.$set(item, "mzinorout", this.ruleForm.inorout);
            this.$set(item, "mzsheng", this.ruleForm.sheng);
            this.$set(item, "mzshi", this.ruleForm.shi);
            this.$set(item, "mzxian", this.ruleForm.xian);
            this.$set(item, "mzzhen", this.ruleForm.zhen);
            this.$set(item, "mzzdydz", this.ruleForm.zdydz);
        },
        peqssameCzd(item) {
            this.$set(item, "mzinorout", this.ruleForm.czinorout);
            this.$set(item, "mzsheng", this.ruleForm.czsheng);
            this.$set(item, "mzshi", this.ruleForm.czshi);
            this.$set(item, "mzxian", this.ruleForm.czxian);
            this.$set(item, "mzzhen", this.ruleForm.czzhen);
            this.$set(item, "mzzdydz", this.ruleForm.czzdydz);
        },
        peqssameQrd(item) {
            let ind = this.$refs.migrationRef.migrationForm.migrationList.length - 1;
            let data = this.$refs.migrationRef.migrationForm.migrationList;
            if (data[ind].qrsheng && this.ruleForm.sfqx == 1) {
                this.$set(item, "mzinorout", data[ind].qrinorout);
                this.$set(item, "mzsheng", data[ind].qrsheng);
                this.$set(item, "mzshi", data[ind].qrshi);
                this.$set(item, "mzxian", data[ind].qrxian);
                this.$set(item, "mzzhen", data[ind].qrzhen);
                this.$set(item, "mzzdydz", data[ind].qrdizhi);
            } else {
                this.$message({ message: "请先选择迁入地", type: "warning" });
            }
        },
        printpezt(item) {},
        // mapOpen(index, dtdz, dizhi) {
        //     this.poindex = index;
        //     this.podtdz = dtdz;
        //     this.podizhi = dizhi;
        //     this.dialogMap = true;
        // },
        // getPosi(lng, lat, address) {
        //     // this.dtdz = lng + ", " + lat;
        //     // this.dizhi = address;
        //     this.ruleForm.spouseList[this.poindex].mzdtdz = lng + ", " + lat;
        //     this.ruleForm.spouseList[this.poindex].mzzdydz = address;
        //     this.dialogMap = false;
        //     // this.$set(this.ruleForm, this.maKkey, );
        //     // this.$set(this.ruleForm, "czzdydz", address);
        // },
        getValue(value, index, key, type, ind) {
            if (type == "spouseList") {
                this.ruleForm.spouseList[ind].occupation[index][key] = value;
            } else {
                this.ruleForm.occupation[index][key] = value;
            }
        },
        getZyValue(value, index, key, type, ind) {
            if (type == "spouseList") {
                this.ruleForm.spouseList[ind].previous[index][key] = value;
            } else {
                this.ruleForm.previous[index][key] = value;
            }
        },
        allspouseList() {
            this.ruleForm.spouseList.push(this.$utils.sData());
        },
        delspouseList() {
            if (this.ruleForm.spouseList.length > 1) {
                this.ruleForm.spouseList.splice(this.ruleForm.spouseList.length - 1, 1);
            }
        },
        inputIschange(e) {
            if (e == 1) {
                this.ruleForm.xm = "";
            }
        }
    },
    components: {
        date,
        Area,
        migration,
        vmap,
        treeSelect
    },
    watch: {
        pType: {
            immediate: true,
            handler: function(val, oldVal) {
                this.routeType = val;
                this.submitText = "保存并填写下一项";
                switch (val) {
                    case "info":
                        this.navtext = "个人基本信息";
                        break;
                    case "personal":
                        this.navtext = "联系信息";
                        this.submitText = "保存并填写下一项";
                        break;
                    case "funeral":
                        this.navtext = "去世安葬信息";
                        this.submitText = "保存并填写下一项";
                        break;
                    case "spouse":
                        this.navtext = "配偶生育信息";
                        this.submitText = "保存并填写下一项";
                        break;
                    case "zlhz":
                        this.navtext = "汇总信息";
                        this.submitText = "保存";
                        break;
                }
            },
            // 深度观察监听
            deep: true
        }
    },
    computed: {
        toChies() {
            return function(val) {
                return this.$utils.toChies(val);
            };
        }
    }
};
</script>
<style lang="less" scoped>
.basic {
    color: #000 !important;

    .basicCon {
        padding-left: 20px;
    }

    .el-form {
        position: relative;

        .avatorForm {
            position: absolute;
            right: 120px;
            top: 15px;
            z-index: 1000;
        }

        .avatorSpan {
            display: inline-block;
            height: 120px;
            line-height: 120px;
            width: 88px;
            vertical-align: top;
            margin-right: 10px;
            border: 1px dashed #d9d9d9;
            position: relative;
            text-align: center;

            i {
                position: absolute;
                top: 0;
                right: 0;
                cursor: pointer;
                display: none;
                width: 20px;
                height: 20px;
                line-height: 20px;
                font-size: 16px;
                color: #fff;
                background-color: #606266;
                z-index: 999;
                border-radius: 50%;
            }

            .el-image {
                width: 100%;
                height: 100%;

                /deep/ img {
                    width: 90%;
                    height: 90%;
                    vertical-align: middle;
                }
            }
        }

        .avatorSpan:hover {
            i {
                display: block;
            }
        }

        .avator {
            border: 1px dashed #d9d9d9;
            text-align: center;
            cursor: pointer;
            display: inline-block;
            height: 120px;
            width: 88px;
            line-height: 120px;

            img {
                width: 100%;
                vertical-align: middle;
            }
        }

        /deep/ .el-form-item__label {
            font-weight: 700 !important;
        }

        table,
        td,
        th {
            text-align: center;
            font-weight: normal;
        }

        table {
            /deep/ .el-input__inner {
                border: 0 !important;
            }
        }
    }
}

.migrationDiv {
    .el-dialog__body {
        > div {
            > div {
                display: inline-block;
                vertical-align: top;
                margin-top: 10px;
            }

            > div:nth-child(1) {
                margin: 20px 10px 0 0;
            }
        }

        button {
            margin: 10px 0 0 70px;
        }
    }
}
/deep/.lioverhide {
    top: 40px !important;
    left: 0 !important;
    max-height: 500px;
    overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/views/info/child.vue